export const MANUFACTURER = 'manufacturer';
export const LINE = 'line';
export const MATTRESS_COLLECTION = 'mattresscollection';
export const COLLECTION = 'collection';
export const MATTRESS = 'mattress';
export const MODEL = 'model';
export const STORE = 'store';
export const RETAILER = 'retailer';

export const MATTRESS_HIERARCHY_CLASSNAMES = {
  [MANUFACTURER]: MANUFACTURER,
  [LINE]: LINE,
  [MATTRESS_COLLECTION]: COLLECTION,
  [MATTRESS]: MODEL,
};

export const CLASSNAMES = {
  ...MATTRESS_HIERARCHY_CLASSNAMES,
  [STORE]: STORE,
  [RETAILER]: RETAILER,
};
